import { useState } from 'react';

import { addRecentKeyword, getRecentKeywords, type RecentKeyword, removeRecentKeyword } from '@/shared/lib/storage';
import { getRecentAssets } from '@/shared/lib/storage/recentAssets';
import type { RecentAsset } from '@/shared/types/recentAssets';

const MAX_RECENT_ITEMS_TO_SHOW = 5;

export const useRecentSearchHistory = () => {
  const [recentAssets, setRecentAssets] = useState<RecentAsset[]>([]);
  const [keywords, setKeywords] = useState<RecentKeyword[]>([]);

  const refresh = () => {
    const assets = getRecentAssets().slice(0, MAX_RECENT_ITEMS_TO_SHOW);
    const recentKeywords = getRecentKeywords().slice(0, MAX_RECENT_ITEMS_TO_SHOW);
    setRecentAssets(assets);
    setKeywords(recentKeywords);
  };

  const addKeyword = (keyword: string) => {
    if (keyword.trim()) {
      addRecentKeyword(keyword);
    }
  };

  const removeKeyword = (keyword: string) => {
    removeRecentKeyword(keyword);
    refresh();
  };

  return {
    recentAssets,
    keywords,
    addKeyword,
    removeKeyword,
    refresh,
  };
};
